import React from "react"
import { CarouselComponent } from "../CarouselComponent"

export const NursesTeachersWelcomeComponent = () => {
  return (
    <CarouselComponent images={["/images/NursesTeachers/NurseTeacherHeader.jpg"]}>
        <div className="row">
          <div className="col mx-auto">
            <h1 className="text-center">Special Thanking for Nurses and Teachers</h1>
          </div>
        </div>
    </CarouselComponent>
  )
}
